import React from "react";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import Pagination from "@material-ui/lab/Pagination";
import CmtCard from "@coremat/CmtCard";
import CmtCardContent from "@coremat/CmtCard/CmtCardContent";
import moment from "moment-jalaali";

const InventoryLogCard = ({
  logs,
  page,
  totalPages,
  purchaseSource,
  onPurchaseSourceChange,
  onPageChange,
}) => (
  <Box mt={3}>
    <CmtCard>
      <CmtCardContent>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          flexWrap="wrap"
          mb={2}
        >
          <Typography variant="h3">تاریخچه تغییرات موجودی</Typography>
          <FormControl variant="outlined" style={{ minWidth: 180 }}>
            <InputLabel id="inventory-log-source-label">منبع تغییر</InputLabel>
            <Select
              labelId="inventory-log-source-label"
              value={purchaseSource}
              onChange={onPurchaseSourceChange}
              label="منبع تغییر"
            >
              <MenuItem value="All">همه</MenuItem>
              <MenuItem value="User">خرید کاربر</MenuItem>
              <MenuItem value="Admin">تغییر مدیر</MenuItem>
            </Select>
          </FormControl>
        </Box>

        {logs.length === 0 ? (
          <Box py={4} textAlign="center">
            <Typography color="textSecondary">
              تغییری در موجودی ثبت نشده است
            </Typography>
          </Box>
        ) : (
          <div className="Cmt-table-responsive">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>مقدار تغییر</TableCell>
                  <TableCell>توضیحات</TableCell>
                  <TableCell>ثبت‌کننده</TableCell>
                  <TableCell>تاریخ</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {logs.map((log) => (
                  <TableRow key={log._id}>
                    <TableCell>
                      <Typography
                        component="span"
                        style={{
                          color: log.value >= 0 ? "#2e7d32" : "#c62828",
                          fontWeight: "bold",
                        }}
                      >
                        {log.value > 0 ? `+${log.value}` : log.value}
                      </Typography>
                    </TableCell>
                    <TableCell>{log.description}</TableCell>
                    <TableCell>{log.user?.fullName || "-"}</TableCell>
                    <TableCell>
                      {moment(log.createdAt).format("HH:mm - jYYYY/jMM/jDD")}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        )}

        {totalPages > 1 && (
          <Box display="flex" justifyContent="center" mt={3}>
            <Pagination
              count={totalPages}
              page={page}
              color="primary"
              onChange={onPageChange}
            />
          </Box>
        )}
      </CmtCardContent>
    </CmtCard>
  </Box>
);

export default InventoryLogCard;
